module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAAAQCAYAAADgfRjGAAAA/UlEQVRoQ+2aTQrCMBCFJwvPNDmOC7eeQTyFBU80dyqMdNESxGjcTFrydRkKL/nePPKbhA8CEAgnYGYPd7+klKYUro4gBCAgZuYLBnefCSEFAYEOBNYQLtKEsIMBSEKAEFIDEOhMgBB2NgB5CBBCagACQQTKU1BVva6yhDDIAGQgUJ6C5pxPhJCagEAwgXLGU9XtIJSZMNgI5MYl0BRCM7uNi4iRQ+A7AVW9tzBq2ftVZ0JC2IKYf0Yl8EcItxcwtb0fy9FRq4hxhxBoWXYSwhArEBmVACEc1XnGvRsCRQhnVf10FVFt5+3obmykI0cmYGZPETmLyPR2Kf+z/QWC7prOwiLO/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/about/A10_xgsm/titleL.png
// module id = LZTM
// module chunks = 0